import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { MouseEvent, useCallback, useState } from "react";
import { useAlert } from "react-alert";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import {
  useDownloadDocumentQuery,
  useLazyDownloadDocumentQuery,
} from "../../../redux/Documents/documentSlice";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import CandiadateResumePopup from "./CandiadateResumePopup";
import UpdateResume from "./UpdateResume";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.mjs`;

type Props = {
  candidate?: CandidateDetails;
};

// Utility to format bytes to KB/MB
// function formatBytes(bytes?: number | null): string {
//   if (bytes == null || isNaN(bytes)) return "";
//   if (bytes < 1024) return `${bytes} bytes`;
//   if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
//   return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
// }

// Utility to check if a URL is a PDF
function isPdf(url?: string): boolean {
  if (!url) return false;
  try {
    const u = new URL(url);
    return u.pathname.toLowerCase().endsWith(".pdf");
  } catch {
    // fallback for non-URL strings
    return url.toLowerCase().includes(".pdf");
  }
}

const CandidateResume = ({ candidate }: Props) => {
  const [showPreview, setShowPreview] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const onClickThumbnail = useCallback(() => {
    setOpenPopup(true);
  }, []);
  const closePopup = useCallback(() => {
    setOpenPopup(false);
  }, []);
  const resumeFileName = candidate?.fileName;
  // const [lastUpdated, setLastUpdated] = useState<string | null>(null);
  // const [contentLength, setContentLength] = useState<number | null>(null);
  const [downloadDocUrl, { isFetching }] = useLazyDownloadDocumentQuery();

  const alert = useAlert();

  const downloadCV = useCallback(
    async (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      if (resumeFileName) {
        try {
          const result = await downloadDocUrl({
            fileName: resumeFileName,
          }).unwrap();
          window.open(result.link, "_blank");
        } catch (e) {
          alert.error("Error downloading document");
        }
      }
    },
    [alert, resumeFileName, downloadDocUrl],
  );

  const { data: cvUrl } = useDownloadDocumentQuery(
    {
      fileName: resumeFileName || "",
    },
    {
      skip: (resumeFileName || "").length === 0,
      refetchOnMountOrArgChange: true,
    },
  );

  // const fetchHeader = useCallback(async () => {
  //   try {
  //     if (!cvUrl?.link) return;
  //     const response = await axios.get(cvUrl.link);
  //     setLastUpdated(response.headers["last-modified"]);
  //     setContentLength(Number(response.headers["content-length"]));
  //   } catch (error) {
  //     setLastUpdated(new Date().toISOString());
  //     setContentLength(0);
  //   }
  // }, [cvUrl]);

  // useEffect(() => {
  //   fetchHeader();
  // }, [fetchHeader]);

  return (
    <Grid
      container
      item
      width={"100%"}
      height={"100%"}
      gap={3}
      wrap="nowrap"
      mt={2}
    >
      <CandiadateResumePopup
        resumeUrl={cvUrl?.link || ""}
        candidateName={candidate?.name}
        open={openPopup}
        onClose={closePopup}
      />
      {isPdf(cvUrl?.link) && (
        <Grid
          item
          border={"3px solid #D9D9D9"}
          borderRadius={"4px"}
          style={{ cursor: "pointer" }}
        >
          <Document
            file={cvUrl?.link}
            onLoadSuccess={() => {
              setShowPreview(true);
            }}
            onLoadError={() => setShowPreview(false)}
          >
            {showPreview && (
              <Page
                renderAnnotationLayer={false}
                onClick={onClickThumbnail}
                renderTextLayer={false}
                pageNumber={1}
                width={108}
                height={154}
              />
            )}
          </Document>
        </Grid>
      )}
      <Grid container item gap={1} flexDirection="column">
        <Typography
          fontSize={"18px"}
          lineHeight={"18px"}
          color={"#0F1829"}
          fontWeight={700}
        >
          {candidate?.name}'s CV
        </Typography>
        {/* <Grid container item alignItems="center" gap={1}>
          <Grid item>
            <Typography color={"#A16AE8"} fontSize={"14px"} maxWidth={"400px"}>
              {candidate?.fileName}
            </Typography>
            <Typography color={"#A3A0A0"} fontSize={"12px"}>
              Updated {moment(lastUpdated).format("Do MMMM YYYY, h:mm:ss a")}
            </Typography>
          </Grid>
          <Typography color={"#667086"} fontSize={"14px"}>
            {formatBytes(contentLength)}{" "}
          </Typography>
        </Grid> */}
        <Grid container item gap={2} mt={2}>
          <Button
            variant="outlined"
            disabled={!resumeFileName}
            onClick={downloadCV}
          >
            {isFetching ? (
              <CircularProgress size={20}></CircularProgress>
            ) : (
              "Download Resume"
            )}
          </Button>
          <UpdateResume candidate={candidate} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CandidateResume;
